/**
 * Check if the current viewport is mobile
 * @param {number} [breakpoint=1024] - breakpoint in pixels
 * @returns {boolean}
 */
function isMedium(breakpoint) {
	return $(window).width() > (breakpoint || 1024);
}

module.exports = isMedium;
